/** Voice runtimes used by runtime selection, experiments, and telemetry. */
export enum VoiceAgentRuntime {
  GptLive = "gpt_live",
  Legacy = "legacy",
  SlowThinker = "slow_thinker",
}

/** Bounded Slow Thinker runtime failures persisted in traces and transfer audit metadata. */
export enum SlowThinkerRuntimeFailureType {
  SpeechPlaybackDidNotStart = "speech_playback_did_not_start",
  Unknown = "unknown",
}

/** Whether a fail-closed workflow handoff came from a negative policy verdict or missing policy evidence. */
export enum WorkflowPolicyDecision {
  Blocked = "blocked",
  Unavailable = "unavailable",
}
